import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { AttendeeFeatureRoutingModule } from "./attendee-feature-routing.module";
import { SharedService } from "../../modules/shared/services/shared.service";
import { LocalDataService } from "../../modules/shared/services/local-data.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AccountService } from "../../modules/shared/services/account.service";
import { EventService } from "../../modules/shared/services/event.service";
import { CatalogService } from "../../modules/shared/services/catalog.service";
import { FlashMessagesModule } from "angular2-flash-messages";
import { SharedModule } from "../shared-module/shared-module";
import { DragScrollModule } from "ngx-drag-scroll";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { InfiniteScrollModule } from "ngx-infinite-scroll";

import {
    AttendeeFeatureView,
    CatalogContextView,
    SessionSectionView,
    TabSectionView,
    ListService,
    DefaultDrawerView,
    DefaultPopupView
} from ".";
import {
    CclListModule,
    CclNavigationModule,
    CclSharedModule,
    CclLayoutModule,
    CclPageBuilderModule,
    CclPaletteModule,
    CclTemplateResolverService,
    CclNavbarSecondaryService,
    CclBuilderService,
    CclFormsModule,
    CclMessageService,
    CclQuestionBuilderModule
} from "certain-common-library";
import { CommonModule, DatePipe } from "@angular/common";
import { Ng2SearchPipeModule } from "ng2-search-filter";

@NgModule({
    declarations: [
        AttendeeFeatureView,
        CatalogContextView,
        SessionSectionView,
        TabSectionView,
        DefaultDrawerView,
        DefaultPopupView
    ],
    imports: [
        CommonModule,
        AttendeeFeatureRoutingModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        CclListModule,
        CclNavigationModule,
        CclSharedModule,
        CclLayoutModule,
        CclPageBuilderModule,
        CclPaletteModule,
        CclFormsModule,
        CclQuestionBuilderModule,
        FlashMessagesModule.forRoot(),
        SharedModule,
        DragScrollModule,
        SlickCarouselModule,
        NgxSmartModalModule.forRoot(),
        InfiniteScrollModule,
        Ng2SearchPipeModule
    ],
    providers: [
        CclTemplateResolverService,
        CclNavbarSecondaryService,
        CclBuilderService,
        CclMessageService,
        ListService,
        SharedService,
        LocalDataService,
        AccountService,
        EventService,
        CatalogService,
        DatePipe
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
    ]
})
export class AttendeeFeatureModule {}
